import Report from './Report'

export default Report



// WEBPACK FOOTER //
// ./src/views/Report/index.js